import { createSlice } from '@reduxjs/toolkit'
import { IStore } from '../types'
import { getStat, getStatBlock2, searchStat, searchStatBlock2 } from './actions'

const initialState: IStore['statNews'] = {
  data: null,
  dataRating: null,
  searchData: null,
  searchDataRating: null,
}

export const slice = createSlice({
  name: 'statNews',
  initialState,
  reducers: {
    setData: (state, action) => ({ ...state, searchData: action.payload }),
    setDataRating: (state, action) => ({ ...state, searchDataRating: action.payload }),
  },
  extraReducers: (builder) => {
    builder.addCase(getStat.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getStatBlock2.fulfilled, (state, action) => {
      state.dataRating = action.payload
    })
    builder.addCase(searchStat.fulfilled, (state, action) => {
      state.searchData = action.payload
    })
    builder.addCase(searchStatBlock2.fulfilled, (state, action) => {
      state.searchDataRating = action.payload
    })
  },
})

export const StatNewsActions = slice.actions

export default slice.reducer
